module.exports = __webpack_public_path__ + "img/01-1第三个3年.a04fcac5.png";